module.exports = __webpack_public_path__ + "static/media/slider-l1-360.afcb80ac.webp";